import script from "./InputPercentage.vue?vue&type=script&setup=true&lang=js"
export * from "./InputPercentage.vue?vue&type=script&setup=true&lang=js"

import "./InputPercentage.vue?vue&type=style&index=0&id=e2939110&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2939110"]])

export default __exports__